module.exports = __webpack_public_path__ + "img/qrcode1.0b8f1f55.png";